import { getCookie, setCookie } from './cookies';
import { defaultOverviewFilterSet } from '../constants/overviewFilters';

const SORABAN_OVERVIEW_FILTERS_COOKIE =
  'SORABAN_OVERVIEW_FILTERS_COOKIE_2024-03-30';
const SORABAN_OVERVIEW_FILTERS_EXPIRE_DAYS = 30;

export const storeFilterRecord = (tabName, filterName, value) => {
  const storedFilterSet = getStoredFilters();
  let newFilterSet = { ...storedFilterSet };

  newFilterSet[tabName] = {
    ...storedFilterSet[tabName],
    [filterName]: value,
  };

  const cookieString = JSON.stringify(newFilterSet);

  return setCookie(
    SORABAN_OVERVIEW_FILTERS_COOKIE,
    cookieString,
    SORABAN_OVERVIEW_FILTERS_EXPIRE_DAYS,
  );
};

export const getStoredFilters = () => {
  try {
    const jsonString = getCookie(SORABAN_OVERVIEW_FILTERS_COOKIE);
    const filterSet = jsonString
      ? JSON.parse(jsonString)
      : defaultOverviewFilterSet;

    return filterSet;
  } catch (error) {
    console.error(error);

    return defaultOverviewFilterSet;
  }
};

export const resetStoredFilterTab = tabName => {
  const storedFilterSet = getStoredFilters();
  let newFilterSet = { ...storedFilterSet };
  newFilterSet[tabName] = defaultOverviewFilterSet[tabName];

  const cookieString = JSON.stringify(newFilterSet);

  return setCookie(
    SORABAN_OVERVIEW_FILTERS_COOKIE,
    cookieString,
    SORABAN_OVERVIEW_FILTERS_EXPIRE_DAYS,
  );
};

export const compareFilters = (first, second) => {
  if (!first && !!second) return false;
  if (!second && !!first) return false;

  return JSON.stringify(first) !== JSON.stringify(second);
};
